<template>
  <main class="app-container">
    <course-filter @onSearch="onSearch" />
    <div :style="`height: ${height}px;`">

    <md-scroll-view
            ref="scrollView"
            :scrolling-x="false"
            @end-reached="onReachBottom"
    >

      <list-loading v-show="listData.loading && listData.query.page == 1" />

      <div class="no-result" v-show="!listData.loading && listData.data.length < 1">暂无数据</div>

      <CourseItem
              v-for="item in listData.data"
              :key="item.id"
              :course="item"
      />

      <md-scroll-view-more
              slot="more"
              finished-text=""
              :is-finished="listData.hasNextPage == false"
      >
      </md-scroll-view-more>
    </md-scroll-view>
    </div>

    <tab-bar></tab-bar>
  </main>
</template>

<script>
import CourseItem from "../components/CourseItem.vue";
import CourseFilter from "../components/CourseFilter.vue";
import ListLoading from "../components/ListLoading.vue";
import listDataMixin from "../mixins/list-data";
import {ScrollView, ScrollViewMore} from 'mand-mobile'
import TabBar from "../components/TabBar"
import { mapState } from 'vuex'
import WechatSdk from "../untils/wechat-sdk";


export default {
  components: {
    CourseItem, ListLoading,TabBar,CourseFilter,
    [ScrollView.name]: ScrollView,
    [ScrollViewMore.name]: ScrollViewMore,
  },
    mixins: [listDataMixin],
  data() {
    return {
        height: window.screen.height,
        apiEndpoint: 'courses',
    }
  },
    computed: {
        ...mapState({
            lat: state => {
                console.log('computed', state.geoLocation);
                return state.geoLocation.lat;
            },
            lng: state => state.geoLocation.lng
        })
    },
  created() {
      //this.$http.get('/courses').then(({data}) => console.log(data));
      //this.loadData();
      this.listData.loading = true;
      this.$store.dispatch('geoLocation/init')
          .then(() => {
            console.log('get geo success');
              this.onSearch({sort:'nearby'});
          })
          .catch(() => {
              console.log('get geo failed');
              this.onSearch({sort:'latest'});
          });
//
      this.setShareData();
  },
    mounted() {
      console.log('mounted');
      console.log(document.querySelector("#ch-tab-bar").offsetHeight);
        this.height = window.screen.height - document.querySelector("#ch-tab-bar").offsetHeight - document.querySelector("#ch-filter-bar").offsetHeight;
    },
    methods: {
      loadData() {
          this.loading = true;
          this.$http.get('/courses', {page:this.page})
              .then(({data}) => {
                  console.log(data);
                  this.loading = false;
              })
              .catch(() => {
                this.$toast.failed("加载失败");
              });
      },
        onSearch(filter) {
            console.log(filter);
            this.initListData();
            const {query} = this.listData;
            this.listData.query = {...query, ...filter, lat:this.lat,lng:this.lng};
            console.log(this.listData.query);
            this.loadListData();
        },
        setShareData() {
            const logo = "http://tofino.oss-cn-chengdu.aliyuncs.com/logo.png";
            const des = "“Wondergarten 出来玩”是一所没有围墙的学校，一个致力于链接家庭、自然、教育资源，把家庭聚集在户外环境，让孩子通过游戏学习的平台。";
            WechatSdk.updateAppMessageShareData({
                title: 'Wondergarten 出来玩 - 课程报名', // 分享标题
                desc: des, // 分享描述
                link: window.location.origin + this.$route.fullPath,
                imgUrl: logo, // 分享图标
            });
            WechatSdk.updateTimelineShareData({
                title: 'Wondergarten 出来玩 - 课程报名', // 分享标题
                link: window.location.origin + this.$route.fullPath,
                imgUrl: logo, // 分享图标
            });
        },
    }
}

</script>

<style lang="scss" scoped>
.app-container {
  height: 100%;
}

</style>

